import React, { useState } from "react";
import { Tabs } from "antd";
import { BasicPageHeader } from "./BasicPageHeader"
import { ContractPageHeader } from "./ContractPageHeader"
import { BasicDataBox } from "./BasicDataBox";
import { ContractDataBox } from "./ContractDataBox";

export function Roster() {
    const [activeKey, setActiveKey] = useState("1");

    const handleTabChange = (key: string) => {
        setActiveKey(key);
    };

    return (
        <Tabs type="card" defaultActiveKey="1" onChange={handleTabChange} activeKey={activeKey}>
            <Tabs.TabPane tab="基本信息" key="1">
                <BasicPageHeader />
                <BasicDataBox />
            </Tabs.TabPane>
            <Tabs.TabPane tab="合同信息" key="2">
                <ContractPageHeader />
                <ContractDataBox />
            </Tabs.TabPane>
        </Tabs>
    )
}